/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, {useRef, useEffect} from "react";
import {useLoader, useThree} from "react-three-fiber";
import {GLTFLoader, GLTF} from "three/examples/jsm/loaders/GLTFLoader";
import {convertToPhongMaterials} from "../../utils";
import useScreenshotStore from "../screenshot/useScreenshotStore";
import GiftsMngr from "./GiftsMngr";
import {DoubleSide} from "three";

import Logos from "./Logos";
import Entorno from "./Entorno";

type GLTFResult = GLTF & {
  nodes: {
    Glass: THREE.Mesh;
    Parking: THREE.Mesh;
    Rejas: THREE.Mesh;
    Torre_logo: THREE.Mesh;
    Main_screen: THREE.Mesh;
    Metal: THREE.Mesh;
    Grass: THREE.Mesh;
    Floor: THREE.Mesh;
    Herringbone: THREE.Mesh;
    Brick: THREE.Mesh;
    Sky_2: THREE.Mesh;
    Sky_3: THREE.Mesh;
    Sky_1: THREE.Mesh;
    Main: THREE.Mesh;
  };
  materials: {
    ["Glass.001"]: THREE.MeshStandardMaterial;
    ["Parking.001"]: THREE.MeshStandardMaterial;
    ["Fence.001"]: THREE.MeshStandardMaterial;
    ["Torre_logo.001"]: THREE.MeshStandardMaterial;
    ["Main_screen.001"]: THREE.MeshStandardMaterial;
    ["Metal.001"]: THREE.MeshStandardMaterial;
    ["Grass.001"]: THREE.MeshStandardMaterial;
    ["Floor.001"]: THREE.MeshStandardMaterial;
    ["Herringbone.001"]: THREE.MeshStandardMaterial;
    Brick: THREE.MeshStandardMaterial;
    ["Skyline.001"]: THREE.MeshStandardMaterial;
    ["Color.001"]: THREE.MeshStandardMaterial;
  };
};

export default function Model(props: JSX.IntrinsicElements["group"]) {
  const startDate = new Date("2021-05-07T10:00:00+02:00");
  const endDate = new Date("2021-05-31T23:59:59+02:00");
  const currentDate = Date.now();

  const showGift =
    startDate.getTime() <= currentDate && currentDate <= endDate.getTime();
  //console.log(showGift)

  const group = useRef<THREE.Group>();
  const {nodes, materials} = useLoader<GLTFResult>(
    GLTFLoader,
    "gltf/torre/LTOZv18.gltf"
  );

  convertToPhongMaterials(materials);

  materials["Fence.001"].side = DoubleSide;

  const {
    scene,
    camera,
    gl,
    gl: {domElement},
  } = useThree();

  const {screenshotCam} = useScreenshotStore();

  useEffect(() => {
    screenshotCam.init(domElement, gl, camera, scene);
  }, [screenshotCam, domElement, gl, camera, scene]);

  return (
    <group ref={group} {...props} dispose={null}>
      <Logos />
      <Entorno />
    </group>
  );
}
